module.exports = __webpack_public_path__ + "img/solarroof@2x.3093bf3.webp";